import { create } from 'zustand';
import { produce } from 'immer';
import { persist } from 'zustand/middleware';

// internal
import * as store from '../types/store/project-handle';
import * as state from '../types/store/project-state';

const initState: state.ProjectState = {
  id: '',
  name: '',
  projectId: '',
  deploymentId: '',
  client: '',
  closedloopProjectId: '',
  nodename: '',
  callcenter: false,
  closedloopDeploymentId: '',
};

export const useProjectStore = create<store.ProjectStore>()(
  persist(
    (set, get) => ({
      ...initState,
      init: (data) => {
        set(
          produce<state.ProjectState>((state) => {
            state.id = data.id;
            state.name = data.name;
            state.projectId = data.project_id;
            state.nodename = data.nodename;
            state.deploymentId = data.deployment_id;
            state.client = data.client;
            state.closedloopProjectId = data.closedloop_project_id;
            state.callcenter = data.callcenter;
            state.closedloopDeploymentId = data.closedloop_deployment_id;
          }),
        );
      },
      reset: () => {
        set(
          produce<state.ProjectState>((state) => {
            state.id = '';
            state.name = '';
            state.projectId = '';
            state.nodename = '';
            state.deploymentId = '';
            state.client = '';
            state.closedloopProjectId = '';
            state.callcenter = false;
            state.closedloopDeploymentId = '';
          }),
        );
      },
    }),
    {
      name: 'fullloop/project_data',
    },
  ),
);
